import React from "react";
import "./Order_list_table.css";
import { Form } from "react-bootstrap";
import { encodeId, variant_type, getVariantImage } from "../../../../utils/common";
import { Link } from "react-router-dom";

function Order_list_table({
  order,
  selectedItems,
  setSelectedItems,
  setError,
  error,
}) {
  const handleCheckboxChange = (val) => {
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);

      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        setError((prevError) => ({
          ...prevError,
          product: "",
        }));

        return [...prev, val];
      }
    });
  };

  const productSelectionError = error?.product;

  return (
    <>
      <section
        className="Order_details_table Cart_Products_card d-none d-lg-block"
        style={{
          border: productSelectionError
            ? "1px solid red"
            : "1px solid transparent",
          borderRadius: "6px",
        }}
      >
        <div className="inner_box_div">
          {order?.Product_Order_Details?.map((val) => (
            <div className="row align-items-center inner_card" key={val?.id}>
              <div className="cancel_check_div">
                <Form.Check
                  type="checkbox"
                  checked={selectedItems?.some((item) => item.id === val.id)}
                  onChange={() => handleCheckboxChange(val)}
                  disabled={!val?.Product?.is_returnable}
                />
              </div>

              <div className="col-xl-9 col-sm-8">
                <Link
                  to={`/product-details/${encodeId(val?.Product?.id)}`}
                  className="text-decoration-none text-dark"
                >
                  <div className="row">
                    <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={
                            getVariantImage(val)
                          }
                          alt="Product_img"
                        />
                      </div>
                    </div>

                    <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>{val?.Product?.name}</h4>

                          <div className="new">
                            {val?.Product?.variant_type_id ===
                              variant_type.Single && (
                              <>
                                <strong>{val?.Product?.variant_name} : </strong>
                                {val?.Product_Variant?.Metal?.name}
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Double && (
                              <>
                                <strong>{val?.Product?.variant_name} :</strong>{" "}
                                {
                                  val?.Double_Variant?.Product_Variant?.Metal
                                    ?.name
                                }
                                <br />
                                <strong>Size :</strong>{" "}
                                {val?.Double_Variant?.Size?.name}
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Triple && (
                              <>
                                <strong>{val?.Product?.variant_name} :</strong>{" "}
                                {
                                  val?.Triple_Variant?.Double_Variant
                                    ?.Product_Variant?.Metal?.name
                                }
                                <br />
                                <strong>Size:</strong>{" "}
                                {
                                  val?.Triple_Variant?.Double_Variant?.Size
                                    ?.name
                                }
                                , <strong>Diamond:</strong>{" "}
                                {val?.Triple_Variant?.Diamond?.name}
                              </>
                            )}
                          </div>

                          {val?.Product_Variant?.name && (
                            <p className="mb-1">
                              <strong>Polish :</strong>{" "}
                              {val?.Product_Variant?.name}
                            </p>
                          )}

                          {val?.Double_Variant?.name && (
                            <p className="mb-1">
                              <strong>Colour :</strong>{" "}
                              {val?.Double_Variant?.name}
                            </p>
                          )}

                          {val?.Triple_Variant?.name && (
                            <p className="mb-1">
                              <strong>Size :</strong>{" "}
                              {val?.Triple_Variant?.name}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-xl-3 col-sm-4">
                <div className="new_price_holder">
                  <div className="price_inner_text">
                    <p className="right_label">Price </p>
                    <p className="colon_text">:</p>₹{val?.selling_price}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Order Qty </p>
                    <p className="colon_text">:</p>
                    {val?.quantity}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Total Price </p>
                    <p className="colon_text">:</p>₹{" "}
                    {val?.quantity * val?.selling_price}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {productSelectionError && (
        <p
          style={{
            color: "red",
            fontSize: "14px",
            marginTop: "8px",
            marginBottom: "10px",
          }}
        >
          {error?.product}
        </p>
      )}

      {/* Mobile */}
      <div className="d-block d-lg-none mobile_view_holder">
        {order?.Product_Order_Details?.map((val) => (
          <div
            className="mobile_product_card"
            key={val?.id}
            style={{
              border: productSelectionError
                ? "1px solid red"
                : "1px solid transparent",
              borderRadius: "6px",
            }}
          >
            <div className="cancel_check_div">
              <Form.Check
                type="checkbox"
                checked={selectedItems?.some((item) => item.id === val.id)}
                onChange={() => handleCheckboxChange(val)}
                disabled={!val?.Product?.is_returnable}
              />
            </div>

            <Link
              to={`/product-details/${encodeId(val?.Product?.id)}`}
              className="text-decoration-none text-dark"
            >
              <div className="order_holder">
                <div className="order_holder_left">
                  <div className="img_holder">
                    <img
                      className="Product_img"
                      src={getVariantImage(val)}
                      alt={val?.Product?.name}
                    />
                  </div>
                </div>

                <div className="order_holder_right">
                  <div className="descn_holder">
                    <div className="left_div">
                      <h6 className="product_name mb-2">
                        {val?.Product?.name}
                      </h6>

                      <div className="new">
                        {val?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            <strong>{val?.Product?.variant_name} : </strong>
                            {val?.Product_Variant?.Metal?.name}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            <strong>{val?.Product?.variant_name} :</strong>{" "}
                            {val?.Double_Variant?.Product_Variant?.Metal?.name}
                            <br />
                            <strong>Size :</strong>{" "}
                            {val?.Double_Variant?.Size?.name}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            <strong>{val?.Product?.variant_name} :</strong>{" "}
                            {
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            <br />
                            <strong>Size:</strong>{" "}
                            {val?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                            <strong>Diamond:</strong>{" "}
                            {val?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </div>

                      {val?.Product_Variant?.name && (
                        <p className="mb-1">
                          <strong>Polish :</strong> {val?.Product_Variant?.name}
                        </p>
                      )}

                      {val?.Double_Variant?.name && (
                        <p className="mb-1">
                          <strong>Colour :</strong> {val?.Double_Variant?.name}
                        </p>
                      )}

                      {val?.Triple_Variant?.name && (
                        <p className="mb-1">
                          <strong>Size :</strong> {val?.Triple_Variant?.name}
                        </p>
                      )}
                    </div>

                    <div className="price_details">
                      <p className="mb-1">
                        <strong>₹{val?.selling_price}</strong> X {val?.quantity}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
}

export default Order_list_table;
